module.exports = __webpack_public_path__ + "static/img/happytree-mobile@2x.5396240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/happytree-mobile@2x.png
// module id = wGOI
// module chunks = 1